"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bosniaTranslations = void 0;
var _types = require("../../../types");
const bosniaTranslations = exports.bosniaTranslations = {
  [_types.ErrorPageTranslationKey.headline]: 'Žao nam je!',
  [_types.ErrorPageTranslationKey.buttonText]: 'Povratak',
  [_types.ErrorPageTranslationKey.text]: 'Stranica trenutno nije u funkciji.',
  [_types.ErrorPageTranslationKey.notFound]: 'Stranica kojoj pokušavate pristupiti nije dostupna',
  [_types.ErrorPageTranslationKey.unauthorized]: 'Stranica koju pokušavate posjetiti je ograničena i nisu ispunjeni svi kriteriji.',
  [_types.ErrorPageTranslationKey.contactSupportTeam]: 'Molimo kontaktirajte Oriflame tim za podršku putem e-pošte:',
  [_types.ErrorPageTranslationKey.rejectedUrl]: 'Traženi URL je odbijen!'
};
